import { ICheckoutTheme } from '../../../../../common/theme/ICheckoutTheme';
import { makeStyles } from '@material-ui/core/styles';

export type AccessoriesItemDetailsClasses =
  | 'image'
  | 'details'
  | 'container'
  | 'title'
  | 'description'
  | 'detailsContainer'
  | 'price';

export const imageStyle = {
  width: '100%',
  height: 'unset',
  position: 'relative',
  top: 'unset',
  left: 'unset',
};

const itemDetailsStyles = makeStyles<ICheckoutTheme, AccessoriesItemDetailsClasses>(
  ({ typography }) => ({
    image: {
      display: 'block',
      marginBottom: '15px',
      maxWidth: '100%',
    },
    details: {
      padding: '0 15px',
      textAlign: 'left',
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    title: {
      fontWeight: 700,
      fontSize: typography.fontMD,
      marginBottom: '5px',
      paddingBottom: '40px',
    },
    description: {
      lineHeight: '18px',
    },
    detailsContainer: {},
    price: {
      fontSize: typography.fontMD,
    },
  }),
  { name: 'GqlCheckout_Accessories_ItemDetails' },
);

export default itemDetailsStyles;
